import FJUltraIcon from '../../assets/svg/ultra02.svg?react';
import FJProIcon from '../../assets/svg/pro02.svg?react';
import FJClothesChangerConfig from '../appConfig/FJClothesChangerConfig';

export const CLOTHES_CHANGER_MODEL_LIST = [
    {
        name: 'Max',
        value: 'doubao',
        description: 'max-model-description',
        icon: FJUltraIcon,
        price: FJClothesChangerConfig.maxUnitPrice,
    },
    {
        name: 'Pro',
        value: 'fal',
        description: 'pro-model-description',
        icon: FJProIcon,
        price: FJClothesChangerConfig.proUnitPrice,
    },
];

export const NEW_CLOTHES_CHANGER_STYLE_LIST = {
    male: [
        {
            categoryName: 'business',
            clothes: [
                {
                    key: 'men_business_01_10.png',
                    garmentFile: 'garment/men_business_01_10.png',
                    effectFile: 'effect/men_business_01_10.png',
                },
                {
                    key: 'men_business_01_13.png',
                    garmentFile: 'garment/men_business_01_13.png',
                    effectFile: 'effect/men_business_01_13.png',
                },
                {
                    key: 'men_business_01_14.png',
                    garmentFile: 'garment/men_business_01_14.png',
                    effectFile: 'effect/men_business_01_14.png',
                },
                {
                    key: 'men_business_01_3.png',
                    garmentFile: 'garment/men_business_01_3.png',
                    effectFile: 'effect/men_business_01_3.png',
                },
                {
                    key: 'men_business_01_4.png',
                    garmentFile: 'garment/men_business_01_4.png',
                    effectFile: 'effect/men_business_01_4.png',
                },
                {
                    key: 'men_business_01_5.png',
                    garmentFile: 'garment/men_business_01_5.png',
                    effectFile: 'effect/men_business_01_5.png',
                },
                {
                    key: 'men_business_01_6.png',
                    garmentFile: 'garment/men_business_01_6.png',
                    effectFile: 'effect/men_business_01_6.png',
                },
                {
                    key: 'men_business_01_7.png',
                    garmentFile: 'garment/men_business_01_7.png',
                    effectFile: 'effect/men_business_01_7.png',
                },
                {
                    key: 'men_business_02_2.png',
                    garmentFile: 'garment/men_business_02_2.png',
                    effectFile: 'effect/men_business_02_2.png',
                },
                {
                    key: 'men_business_02_4.png',
                    garmentFile: 'garment/men_business_02_4.png',
                    effectFile: 'effect/men_business_02_4.png',
                },
                {
                    key: 'men_business_01_1.png',
                    garmentFile: 'garment/men_business_01_1.png',
                    effectFile: 'effect/men_business_01_1.png',
                },
                {
                    key: 'men_business_01_11.png',
                    garmentFile: 'garment/men_business_01_11.png',
                    effectFile: 'effect/men_business_01_11.png',
                },
                {
                    key: 'men_business_01_12.png',
                    garmentFile: 'garment/men_business_01_12.png',
                    effectFile: 'effect/men_business_01_12.png',
                },

                {
                    key: 'men_business_01_2.png',
                    garmentFile: 'garment/men_business_01_2.png',
                    effectFile: 'effect/men_business_01_2.png',
                },
                {
                    key: 'men_business_01_8.png',
                    garmentFile: 'garment/men_business_01_8.png',
                    effectFile: 'effect/men_business_01_8.png',
                },
                {
                    key: 'men_business_01_9.png',
                    garmentFile: 'garment/men_business_01_9.png',
                    effectFile: 'effect/men_business_01_9.png',
                },
                {
                    key: 'men_business_02_1.png',
                    garmentFile: 'garment/men_business_02_1.png',
                    effectFile: 'effect/men_business_02_1.png',
                },
                {
                    key: 'men_business_02_10.png',
                    garmentFile: 'garment/men_business_02_10.png',
                    effectFile: 'effect/men_business_02_10.png',
                },
                {
                    key: 'men_business_02_11.png',
                    garmentFile: 'garment/men_business_02_11.png',
                    effectFile: 'effect/men_business_02_11.png',
                },
                {
                    key: 'men_business_02_12.png',
                    garmentFile: 'garment/men_business_02_12.png',
                    effectFile: 'effect/men_business_02_12.png',
                },
                {
                    key: 'men_business_02_3.png',
                    garmentFile: 'garment/men_business_02_3.png',
                    effectFile: 'effect/men_business_02_3.png',
                },
                {
                    key: 'men_business_02_5.png',
                    garmentFile: 'garment/men_business_02_5.png',
                    effectFile: 'effect/men_business_02_5.png',
                },
                {
                    key: 'men_business_02_6.png',
                    garmentFile: 'garment/men_business_02_6.png',
                    effectFile: 'effect/men_business_02_6.png',
                },
                {
                    key: 'men_business_02_7.png',
                    garmentFile: 'garment/men_business_02_7.png',
                    effectFile: 'effect/men_business_02_7.png',
                },
                {
                    key: 'men_business_02_8.png',
                    garmentFile: 'garment/men_business_02_8.png',
                    effectFile: 'effect/men_business_02_8.png',
                },
                {
                    key: 'men_business_02_9.png',
                    garmentFile: 'garment/men_business_02_9.png',
                    effectFile: 'effect/men_business_02_9.png',
                },
                {
                    key: 'men_business_03_1.png',
                    garmentFile: 'garment/men_business_03_1.png',
                    effectFile: 'effect/men_business_03_1.png',
                },
                {
                    key: 'men_business_03_2.png',
                    garmentFile: 'garment/men_business_03_2.png',
                    effectFile: 'effect/men_business_03_2.png',
                },
                {
                    key: 'men_business_03_3.png',
                    garmentFile: 'garment/men_business_03_3.png',
                    effectFile: 'effect/men_business_03_3.png',
                },
                {
                    key: 'men_business_04_1.png',
                    garmentFile: 'garment/men_business_04_1.png',
                    effectFile: 'effect/men_business_04_1.png',
                },
                {
                    key: 'men_business_04_3.png',
                    garmentFile: 'garment/men_business_04_3.png',
                    effectFile: 'effect/men_business_04_3.png',
                },
                {
                    key: 'men_business_04_2.png',
                    garmentFile: 'garment/men_business_04_2.png',
                    effectFile: 'effect/men_business_04_2.png',
                },
            ],
        },
        {
            categoryName: 'causal',
            clothes: [
                {
                    key: 'men_causal_01_1.png',
                    garmentFile: 'garment/men_causal_01_1.png',
                    effectFile: 'effect/men_causal_01_1.png',
                },
                {
                    key: 'men_causal_01_2.png',
                    garmentFile: 'garment/men_causal_01_2.png',
                    effectFile: 'effect/men_causal_01_2.png',
                },
                {
                    key: 'men_causal_01_4.png',
                    garmentFile: 'garment/men_causal_01_4.png',
                    effectFile: 'effect/men_causal_01_4.png',
                },
                {
                    key: 'men_causal_01_5.png',
                    garmentFile: 'garment/men_causal_01_5.png',
                    effectFile: 'effect/men_causal_01_5.png',
                },
                {
                    key: 'men_causal_01_6.png',
                    garmentFile: 'garment/men_causal_01_6.png',
                    effectFile: 'effect/men_causal_01_6.png',
                },
                {
                    key: 'men_causal_01_7.png',
                    garmentFile: 'garment/men_causal_01_7.png',
                    effectFile: 'effect/men_causal_01_7.png',
                },
                {
                    key: 'men_causal_01_8.png',
                    garmentFile: 'garment/men_causal_01_8.png',
                    effectFile: 'effect/men_causal_01_8.png',
                },
                {
                    key: 'men_causal_01_9.png',
                    garmentFile: 'garment/men_causal_01_9.png',
                    effectFile: 'effect/men_causal_01_9.png',
                },
                {
                    key: 'men_causal_01_10.png',
                    garmentFile: 'garment/men_causal_01_10.png',
                    effectFile: 'effect/men_causal_01_10.png',
                },
                {
                    key: 'men_causal_01_12.png',
                    garmentFile: 'garment/men_causal_01_12.png',
                    effectFile: 'effect/men_causal_01_12.png',
                },
                {
                    key: 'men_causal_01_13.png',
                    garmentFile: 'garment/men_causal_01_13.png',
                    effectFile: 'effect/men_causal_01_13.png',
                },
                {
                    key: 'men_causal_01_14.png',
                    garmentFile: 'garment/men_causal_01_14.png',
                    effectFile: 'effect/men_causal_01_14.png',
                },
                {
                    key: 'men_causal_01_15.png',
                    garmentFile: 'garment/men_causal_01_15.png',
                    effectFile: 'effect/men_causal_01_15.png',
                },
                {
                    key: 'men_causal_01_16.png',
                    garmentFile: 'garment/men_causal_01_16.png',
                    effectFile: 'effect/men_causal_01_16.png',
                },
                {
                    key: 'men_causal_01_17.png',
                    garmentFile: 'garment/men_causal_01_17.png',
                    effectFile: 'effect/men_causal_01_17.png',
                },
                {
                    key: 'men_causal_01_18.png',
                    garmentFile: 'garment/men_causal_01_18.png',
                    effectFile: 'effect/men_causal_01_18.png',
                },
                {
                    key: 'men_causal_01_19.png',
                    garmentFile: 'garment/men_causal_01_19.png',
                    effectFile: 'effect/men_causal_01_19.png',
                },
                {
                    key: 'men_causal_01_20.png',
                    garmentFile: 'garment/men_causal_01_20.png',
                    effectFile: 'effect/men_causal_01_20.png',
                },
                {
                    key: 'men_causal_01_21.png',
                    garmentFile: 'garment/men_causal_01_21.png',
                    effectFile: 'effect/men_causal_01_21.png',
                },
                {
                    key: 'men_causal_01_22.png',
                    garmentFile: 'garment/men_causal_01_22.png',
                    effectFile: 'effect/men_causal_01_22.png',
                },
                {
                    key: 'men_causal_01_23.png',
                    garmentFile: 'garment/men_causal_01_23.png',
                    effectFile: 'effect/men_causal_01_23.png',
                },
                {
                    key: 'men_causal_01_25.png',
                    garmentFile: 'garment/men_causal_01_25.png',
                    effectFile: 'effect/men_causal_01_25.png',
                },
                {
                    key: 'men_causal_01_26.png',
                    garmentFile: 'garment/men_causal_01_26.png',
                    effectFile: 'effect/men_causal_01_26.png',
                },
                {
                    key: 'men_causal_01_27.png',
                    garmentFile: 'garment/men_causal_01_27.png',
                    effectFile: 'effect/men_causal_01_27.png',
                },
                {
                    key: 'men_causal_01_28.png',
                    garmentFile: 'garment/men_causal_01_28.png',
                    effectFile: 'effect/men_causal_01_28.png',
                },
                {
                    key: 'men_causal_01_29.png',
                    garmentFile: 'garment/men_causal_01_29.png',
                    effectFile: 'effect/men_causal_01_29.png',
                },
                {
                    key: 'men_causal_01_30.png',
                    garmentFile: 'garment/men_causal_01_30.png',
                    effectFile: 'effect/men_causal_01_30.png',
                },
                {
                    key: 'men_causal_01_31.png',
                    garmentFile: 'garment/men_causal_01_31.png',
                    effectFile: 'effect/men_causal_01_31.png',
                },
                {
                    key: 'men_causal_01_32.png',
                    garmentFile: 'garment/men_causal_01_32.png',
                    effectFile: 'effect/men_causal_01_32.png',
                },
                {
                    key: 'men_causal_01_33.png',
                    garmentFile: 'garment/men_causal_01_33.png',
                    effectFile: 'effect/men_causal_01_33.png',
                },
                {
                    key: 'men_causal_01_34.png',
                    garmentFile: 'garment/men_causal_01_34.png',
                    effectFile: 'effect/men_causal_01_34.png',
                },
                {
                    key: 'men_causal_01_35.png',
                    garmentFile: 'garment/men_causal_01_35.png',
                    effectFile: 'effect/men_causal_01_35.png',
                },
                {
                    key: 'men_causal_01_36.png',
                    garmentFile: 'garment/men_causal_01_36.png',
                    effectFile: 'effect/men_causal_01_36.png',
                },
                {
                    key: 'men_causal_01_37.png',
                    garmentFile: 'garment/men_causal_01_37.png',
                    effectFile: 'effect/men_causal_01_37.png',
                },
                {
                    key: 'men_causal_01_38.png',
                    garmentFile: 'garment/men_causal_01_38.png',
                    effectFile: 'effect/men_causal_01_38.png',
                },
                {
                    key: 'men_causal_01_39.png',
                    garmentFile: 'garment/men_causal_01_39.png',
                    effectFile: 'effect/men_causal_01_39.png',
                },
                {
                    key: 'men_causal_01_40.png',
                    garmentFile: 'garment/men_causal_01_40.png',
                    effectFile: 'effect/men_causal_01_40.png',
                },
                {
                    key: 'men_causal_01_41.png',
                    garmentFile: 'garment/men_causal_01_41.png',
                    effectFile: 'effect/men_causal_01_41.png',
                },
                {
                    key: 'men_causal_02_1.png',
                    garmentFile: 'garment/men_causal_02_1.png',
                    effectFile: 'effect/men_causal_02_1.png',
                },
                {
                    key: 'men_causal_02_10.png',
                    garmentFile: 'garment/men_causal_02_10.png',
                    effectFile: 'effect/men_causal_02_10.png',
                },
                {
                    key: 'men_causal_02_2.png',
                    garmentFile: 'garment/men_causal_02_2.png',
                    effectFile: 'effect/men_causal_02_2.png',
                },
                {
                    key: 'men_causal_02_3.png',
                    garmentFile: 'garment/men_causal_02_3.png',
                    effectFile: 'effect/men_causal_02_3.png',
                },
                {
                    key: 'men_causal_02_4.png',
                    garmentFile: 'garment/men_causal_02_4.png',
                    effectFile: 'effect/men_causal_02_4.png',
                },
                {
                    key: 'men_causal_02_5.png',
                    garmentFile: 'garment/men_causal_02_5.png',
                    effectFile: 'effect/men_causal_02_5.png',
                },
                {
                    key: 'men_causal_02_6.png',
                    garmentFile: 'garment/men_causal_02_6.png',
                    effectFile: 'effect/men_causal_02_6.png',
                },
                {
                    key: 'men_causal_02_8.png',
                    garmentFile: 'garment/men_causal_02_8.png',
                    effectFile: 'effect/men_causal_02_8.png',
                },
                {
                    key: 'men_causal_02_9.png',
                    garmentFile: 'garment/men_causal_02_9.png',
                    effectFile: 'effect/men_causal_02_9.png',
                },
            ],
        },
        {
            categoryName: 'old-man',
            clothes: [
                {
                    key: 'men_oldman_02_1.png',
                    garmentFile: 'garment/men_oldman_02_1.png',
                    effectFile: 'effect/men_oldman_02_1.png',
                },
                {
                    key: 'men_oldman_02_2.png',
                    garmentFile: 'garment/men_oldman_02_2.png',
                    effectFile: 'effect/men_oldman_02_2.png',
                },
                {
                    key: 'men_oldman_02_3.png',
                    garmentFile: 'garment/men_oldman_02_3.png',
                    effectFile: 'effect/men_oldman_02_3.png',
                },
                {
                    key: 'men_oldman_01_1.png',
                    garmentFile: 'garment/men_oldman_01_1.png',
                    effectFile: 'effect/men_oldman_01_1.png',
                },
                {
                    key: 'men_oldman_01_10.png',
                    garmentFile: 'garment/men_oldman_01_10.png',
                    effectFile: 'effect/men_oldman_01_10.png',
                },
                {
                    key: 'men_oldman_01_11.png',
                    garmentFile: 'garment/men_oldman_01_11.png',
                    effectFile: 'effect/men_oldman_01_11.png',
                },
                {
                    key: 'men_oldman_01_12.png',
                    garmentFile: 'garment/men_oldman_01_12.png',
                    effectFile: 'effect/men_oldman_01_12.png',
                },
                {
                    key: 'men_oldman_01_13.png',
                    garmentFile: 'garment/men_oldman_01_13.png',
                    effectFile: 'effect/men_oldman_01_13.png',
                },
                {
                    key: 'men_oldman_01_14.png',
                    garmentFile: 'garment/men_oldman_01_14.png',
                    effectFile: 'effect/men_oldman_01_14.png',
                },
                {
                    key: 'men_oldman_01_15.png',
                    garmentFile: 'garment/men_oldman_01_15.png',
                    effectFile: 'effect/men_oldman_01_15.png',
                },
                {
                    key: 'men_oldman_01_16.png',
                    garmentFile: 'garment/men_oldman_01_16.png',
                    effectFile: 'effect/men_oldman_01_16.png',
                },
                {
                    key: 'men_oldman_01_2.png',
                    garmentFile: 'garment/men_oldman_01_2.png',
                    effectFile: 'effect/men_oldman_01_2.png',
                },
                {
                    key: 'men_oldman_01_3.png',
                    garmentFile: 'garment/men_oldman_01_3.png',
                    effectFile: 'effect/men_oldman_01_3.png',
                },
                {
                    key: 'men_oldman_01_4.png',
                    garmentFile: 'garment/men_oldman_01_4.png',
                    effectFile: 'effect/men_oldman_01_4.png',
                },
                {
                    key: 'men_oldman_01_5.png',
                    garmentFile: 'garment/men_oldman_01_5.png',
                    effectFile: 'effect/men_oldman_01_5.png',
                },
                {
                    key: 'men_oldman_01_6.png',
                    garmentFile: 'garment/men_oldman_01_6.png',
                    effectFile: 'effect/men_oldman_01_6.png',
                },
                {
                    key: 'men_oldman_01_7.png',
                    garmentFile: 'garment/men_oldman_01_7.png',
                    effectFile: 'effect/men_oldman_01_7.png',
                },
                {
                    key: 'men_oldman_01_8.png',
                    garmentFile: 'garment/men_oldman_01_8.png',
                    effectFile: 'effect/men_oldman_01_8.png',
                },
                {
                    key: 'men_oldman_01_9.png',
                    garmentFile: 'garment/men_oldman_01_9.png',
                    effectFile: 'effect/men_oldman_01_9.png',
                },
            ],
        },
        {
            categoryName: 'pants',
            clothes: [
                {
                    key: 'men_pants_01_1.png',
                    garmentFile: 'garment/men_pants_01_1.png',
                    effectFile: 'effect/men_pants_01_1.png',
                },
                {
                    key: 'men_pants_01_10.png',
                    garmentFile: 'garment/men_pants_01_10.png',
                    effectFile: 'effect/men_pants_01_10.png',
                },
                {
                    key: 'men_pants_01_11.png',
                    garmentFile: 'garment/men_pants_01_11.png',
                    effectFile: 'effect/men_pants_01_11.png',
                },
                {
                    key: 'men_pants_01_12.png',
                    garmentFile: 'garment/men_pants_01_12.png',
                    effectFile: 'effect/men_pants_01_12.png',
                },
                {
                    key: 'men_pants_01_13.png',
                    garmentFile: 'garment/men_pants_01_13.png',
                    effectFile: 'effect/men_pants_01_13.png',
                },
                {
                    key: 'men_pants_01_14.png',
                    garmentFile: 'garment/men_pants_01_14.png',
                    effectFile: 'effect/men_pants_01_14.png',
                },
                {
                    key: 'men_pants_01_15.png',
                    garmentFile: 'garment/men_pants_01_15.png',
                    effectFile: 'effect/men_pants_01_15.png',
                },
                {
                    key: 'men_pants_01_2.png',
                    garmentFile: 'garment/men_pants_01_2.png',
                    effectFile: 'effect/men_pants_01_2.png',
                },
                {
                    key: 'men_pants_01_3.png',
                    garmentFile: 'garment/men_pants_01_3.png',
                    effectFile: 'effect/men_pants_01_3.png',
                },
                {
                    key: 'men_pants_01_4.png',
                    garmentFile: 'garment/men_pants_01_4.png',
                    effectFile: 'effect/men_pants_01_4.png',
                },
                {
                    key: 'men_pants_01_5.png',
                    garmentFile: 'garment/men_pants_01_5.png',
                    effectFile: 'effect/men_pants_01_5.png',
                },
                {
                    key: 'men_pants_01_6.png',
                    garmentFile: 'garment/men_pants_01_6.png',
                    effectFile: 'effect/men_pants_01_6.png',
                },
                {
                    key: 'men_pants_01_7.png',
                    garmentFile: 'garment/men_pants_01_7.png',
                    effectFile: 'effect/men_pants_01_7.png',
                },
                {
                    key: 'men_pants_01_8.png',
                    garmentFile: 'garment/men_pants_01_8.png',
                    effectFile: 'effect/men_pants_01_8.png',
                },
                {
                    key: 'men_pants_01_9.png',
                    garmentFile: 'garment/men_pants_01_9.png',
                    effectFile: 'effect/men_pants_01_9.png',
                },
            ],
        },
        {
            categoryName: 'party',
            clothes: [
                {
                    key: 'men_party_01_1.png',
                    garmentFile: 'garment/men_party_01_1.png',
                    effectFile: 'effect/men_party_01_1.png',
                },
                {
                    key: 'men_party_01_10.png',
                    garmentFile: 'garment/men_party_01_10.png',
                    effectFile: 'effect/men_party_01_10.png',
                },
                {
                    key: 'men_party_01_11.png',
                    garmentFile: 'garment/men_party_01_11.png',
                    effectFile: 'effect/men_party_01_11.png',
                },
                {
                    key: 'men_party_01_12.png',
                    garmentFile: 'garment/men_party_01_12.png',
                    effectFile: 'effect/men_party_01_12.png',
                },
                {
                    key: 'men_party_01_2.png',
                    garmentFile: 'garment/men_party_01_2.png',
                    effectFile: 'effect/men_party_01_2.png',
                },
                {
                    key: 'men_party_01_3.png',
                    garmentFile: 'garment/men_party_01_3.png',
                    effectFile: 'effect/men_party_01_3.png',
                },
                {
                    key: 'men_party_01_4.png',
                    garmentFile: 'garment/men_party_01_4.png',
                    effectFile: 'effect/men_party_01_4.png',
                },
            ],
        },
        {
            categoryName: 'sport',
            clothes: [
                {
                    key: 'men_sport_01_1.png',
                    garmentFile: 'garment/men_sport_01_1.png',
                    effectFile: 'effect/men_sport_01_1.png',
                },
                {
                    key: 'men_sport_01_10.png',
                    garmentFile: 'garment/men_sport_01_10.png',
                    effectFile: 'effect/men_sport_01_10.png',
                },
                {
                    key: 'men_sport_01_11.png',
                    garmentFile: 'garment/men_sport_01_11.png',
                    effectFile: 'effect/men_sport_01_11.png',
                },
                {
                    key: 'men_sport_01_12.png',
                    garmentFile: 'garment/men_sport_01_12.png',
                    effectFile: 'effect/men_sport_01_12.png',
                },
                {
                    key: 'men_sport_01_13.png',
                    garmentFile: 'garment/men_sport_01_13.png',
                    effectFile: 'effect/men_sport_01_13.png',
                },
                {
                    key: 'men_sport_01_2.png',
                    garmentFile: 'garment/men_sport_01_2.png',
                    effectFile: 'effect/men_sport_01_2.png',
                },
                {
                    key: 'men_sport_01_3.png',
                    garmentFile: 'garment/men_sport_01_3.png',
                    effectFile: 'effect/men_sport_01_3.png',
                },
                {
                    key: 'men_sport_01_4.png',
                    garmentFile: 'garment/men_sport_01_4.png',
                    effectFile: 'effect/men_sport_01_4.png',
                },
                {
                    key: 'men_sport_01_5.png',
                    garmentFile: 'garment/men_sport_01_5.png',
                    effectFile: 'effect/men_sport_01_5.png',
                },
                {
                    key: 'men_sport_01_6.png',
                    garmentFile: 'garment/men_sport_01_6.png',
                    effectFile: 'effect/men_sport_01_6.png',
                },
                {
                    key: 'men_sport_01_7.png',
                    garmentFile: 'garment/men_sport_01_7.png',
                    effectFile: 'effect/men_sport_01_7.png',
                },
                {
                    key: 'men_sport_01_8.png',
                    garmentFile: 'garment/men_sport_01_8.png',
                    effectFile: 'effect/men_sport_01_8.png',
                },
                {
                    key: 'men_sport_01_9.png',
                    garmentFile: 'garment/men_sport_01_9.png',
                    effectFile: 'effect/men_sport_01_9.png',
                },
                {
                    key: 'men_sport_03_1.png',
                    garmentFile: 'garment/men_sport_03_1.png',
                    effectFile: 'effect/men_sport_03_1.png',
                },
                {
                    key: 'men_sport_03_2.png',
                    garmentFile: 'garment/men_sport_03_2.png',
                    effectFile: 'effect/men_sport_03_2.png',
                },
                {
                    key: 'men_sport_03_3.png',
                    garmentFile: 'garment/men_sport_03_3.png',
                    effectFile: 'effect/men_sport_03_3.png',
                },
                {
                    key: 'men_sport_03_4.png',
                    garmentFile: 'garment/men_sport_03_4.png',
                    effectFile: 'effect/men_sport_03_4.png',
                },
                {
                    key: 'men_sport_02_2.png',
                    garmentFile: 'garment/men_sport_02_2.png',
                    effectFile: 'effect/men_sport_02_2.png',
                },
                {
                    key: 'men_sport_02_4.png',
                    garmentFile: 'garment/men_sport_02_4.png',
                    effectFile: 'effect/men_sport_02_4.png',
                },
                {
                    key: 'men_sport_02_5.png',
                    garmentFile: 'garment/men_sport_02_5.png',
                    effectFile: 'effect/men_sport_02_5.png',
                },
                {
                    key: 'men_sport_02_6.png',
                    garmentFile: 'garment/men_sport_02_6.png',
                    effectFile: 'effect/men_sport_02_6.png',
                },
                {
                    key: 'men_sport_02_7.png',
                    garmentFile: 'garment/men_sport_02_7.png',
                    effectFile: 'effect/men_sport_02_7.png',
                },
                {
                    key: 'men_sport_02_8.png',
                    garmentFile: 'garment/men_sport_02_8.png',
                    effectFile: 'effect/men_sport_02_8.png',
                },
                {
                    key: 'men_sport_02_9.png',
                    garmentFile: 'garment/men_sport_02_9.png',
                    effectFile: 'effect/men_sport_02_9.png',
                },
                {
                    key: 'men_sport_04_1.png',
                    garmentFile: 'garment/men_sport_04_1.png',
                    effectFile: 'effect/men_sport_04_1.png',
                },
            ],
        },
        {
            categoryName: 'summer',
            clothes: [
                {
                    key: 'men_summer_02_1.png',
                    garmentFile: 'garment/men_summer_02_1.png',
                    effectFile: 'effect/men_summer_02_1.png',
                },
                {
                    key: 'men_summer_02_10.png',
                    garmentFile: 'garment/men_summer_02_10.png',
                    effectFile: 'effect/men_summer_02_10.png',
                },
                {
                    key: 'men_summer_02_2.png',
                    garmentFile: 'garment/men_summer_02_2.png',
                    effectFile: 'effect/men_summer_02_2.png',
                },
                {
                    key: 'men_summer_02_3.png',
                    garmentFile: 'garment/men_summer_02_3.png',
                    effectFile: 'effect/men_summer_02_3.png',
                },
                {
                    key: 'men_summer_02_4.png',
                    garmentFile: 'garment/men_summer_02_4.png',
                    effectFile: 'effect/men_summer_02_4.png',
                },
                {
                    key: 'men_summer_02_5.png',
                    garmentFile: 'garment/men_summer_02_5.png',
                    effectFile: 'effect/men_summer_02_5.png',
                },
                {
                    key: 'men_summer_02_6.png',
                    garmentFile: 'garment/men_summer_02_6.png',
                    effectFile: 'effect/men_summer_02_6.png',
                },
                {
                    key: 'men_summer_02_7.png',
                    garmentFile: 'garment/men_summer_02_7.png',
                    effectFile: 'effect/men_summer_02_7.png',
                },
                {
                    key: 'men_summer_02_8.png',
                    garmentFile: 'garment/men_summer_02_8.png',
                    effectFile: 'effect/men_summer_02_8.png',
                },
                {
                    key: 'men_summer_02_9.png',
                    garmentFile: 'garment/men_summer_02_9.png',
                    effectFile: 'effect/men_summer_02_9.png',
                },
                {
                    key: 'men_summer_03_1.png',
                    garmentFile: 'garment/men_summer_03_1.png',
                    effectFile: 'effect/men_summer_03_1.png',
                },
                {
                    key: 'men_summer_03_10.png',
                    garmentFile: 'garment/men_summer_03_10.png',
                    effectFile: 'effect/men_summer_03_10.png',
                },
                {
                    key: 'men_summer_03_11.png',
                    garmentFile: 'garment/men_summer_03_11.png',
                    effectFile: 'effect/men_summer_03_11.png',
                },
                {
                    key: 'men_summer_03_12.png',
                    garmentFile: 'garment/men_summer_03_12.png',
                    effectFile: 'effect/men_summer_03_12.png',
                },
                {
                    key: 'men_summer_03_13.png',
                    garmentFile: 'garment/men_summer_03_13.png',
                    effectFile: 'effect/men_summer_03_13.png',
                },
                {
                    key: 'men_summer_03_14.png',
                    garmentFile: 'garment/men_summer_03_14.png',
                    effectFile: 'effect/men_summer_03_14.png',
                },
                {
                    key: 'men_summer_03_15.png',
                    garmentFile: 'garment/men_summer_03_15.png',
                    effectFile: 'effect/men_summer_03_15.png',
                },
                {
                    key: 'men_summer_03_2.png',
                    garmentFile: 'garment/men_summer_03_2.png',
                    effectFile: 'effect/men_summer_03_2.png',
                },
                {
                    key: 'men_summer_03_3.png',
                    garmentFile: 'garment/men_summer_03_3.png',
                    effectFile: 'effect/men_summer_03_3.png',
                },
                {
                    key: 'men_summer_03_4.png',
                    garmentFile: 'garment/men_summer_03_4.png',
                    effectFile: 'effect/men_summer_03_4.png',
                },
                {
                    key: 'men_summer_03_5.png',
                    garmentFile: 'garment/men_summer_03_5.png',
                    effectFile: 'effect/men_summer_03_5.png',
                },
                {
                    key: 'men_summer_03_6.png',
                    garmentFile: 'garment/men_summer_03_6.png',
                    effectFile: 'effect/men_summer_03_6.png',
                },
                {
                    key: 'men_summer_03_7.png',
                    garmentFile: 'garment/men_summer_03_7.png',
                    effectFile: 'effect/men_summer_03_7.png',
                },
                {
                    key: 'men_summer_03_8.png',
                    garmentFile: 'garment/men_summer_03_8.png',
                    effectFile: 'effect/men_summer_03_8.png',
                },
                {
                    key: 'men_summer_03_9.png',
                    garmentFile: 'garment/men_summer_03_9.png',
                    effectFile: 'effect/men_summer_03_9.png',
                },
                {
                    key: 'men_summer_01_1.png',
                    garmentFile: 'garment/men_summer_01_1.png',
                    effectFile: 'effect/men_summer_01_1.png',
                },
                {
                    key: 'men_summer_01_10.png',
                    garmentFile: 'garment/men_summer_01_10.png',
                    effectFile: 'effect/men_summer_01_10.png',
                },
                {
                    key: 'men_summer_01_2.png',
                    garmentFile: 'garment/men_summer_01_2.png',
                    effectFile: 'effect/men_summer_01_2.png',
                },
                {
                    key: 'men_summer_01_3.png',
                    garmentFile: 'garment/men_summer_01_3.png',
                    effectFile: 'effect/men_summer_01_3.png',
                },
                {
                    key: 'men_summer_01_4.png',
                    garmentFile: 'garment/men_summer_01_4.png',
                    effectFile: 'effect/men_summer_01_4.png',
                },
                {
                    key: 'men_summer_01_5.png',
                    garmentFile: 'garment/men_summer_01_5.png',
                    effectFile: 'effect/men_summer_01_5.png',
                },
                {
                    key: 'men_summer_01_6.png',
                    garmentFile: 'garment/men_summer_01_6.png',
                    effectFile: 'effect/men_summer_01_6.png',
                },
                {
                    key: 'men_summer_01_7.png',
                    garmentFile: 'garment/men_summer_01_7.png',
                    effectFile: 'effect/men_summer_01_7.png',
                },
                {
                    key: 'men_summer_01_8.png',
                    garmentFile: 'garment/men_summer_01_8.png',
                    effectFile: 'effect/men_summer_01_8.png',
                },
                {
                    key: 'men_summer_01_9.png',
                    garmentFile: 'garment/men_summer_01_9.png',
                    effectFile: 'effect/men_summer_01_9.png',
                },
            ],
        },
        {
            categoryName: 'wedding',
            clothes: [
                {
                    key: 'men_wedding_01_1.png',
                    garmentFile: 'garment/men_wedding_01_1.png',
                    effectFile: 'effect/men_wedding_01_1.png',
                },
                {
                    key: 'men_wedding_01_3.png',
                    garmentFile: 'garment/men_wedding_01_3.png',
                    effectFile: 'effect/men_wedding_01_3.png',
                },
                {
                    key: 'men_wedding_01_4.png',
                    garmentFile: 'garment/men_wedding_01_4.png',
                    effectFile: 'effect/men_wedding_01_4.png',
                },
                {
                    key: 'men_wedding_01_5.png',
                    garmentFile: 'garment/men_wedding_01_5.png',
                    effectFile: 'effect/men_wedding_01_5.png',
                },
                {
                    key: 'men_wedding_01_6.png',
                    garmentFile: 'garment/men_wedding_01_6.png',
                    effectFile: 'effect/men_wedding_01_6.png',
                },
                {
                    key: 'men_wedding_01_7.png',
                    garmentFile: 'garment/men_wedding_01_7.png',
                    effectFile: 'effect/men_wedding_01_7.png',
                },
                {
                    key: 'men_wedding_01_2.png',
                    garmentFile: 'garment/men_wedding_01_2.png',
                    effectFile: 'effect/men_wedding_01_2.png',
                },
            ],
        },
        {
            categoryName: 'winter',
            clothes: [
                {
                    key: 'men_winter_02_1.png',
                    garmentFile: 'garment/men_winter_02_1.png',
                    effectFile: 'effect/men_winter_02_1.png',
                },
                {
                    key: 'men_winter_02_2.png',
                    garmentFile: 'garment/men_winter_02_2.png',
                    effectFile: 'effect/men_winter_02_2.png',
                },
                {
                    key: 'men_winter_02_3.png',
                    garmentFile: 'garment/men_winter_02_3.png',
                    effectFile: 'effect/men_winter_02_3.png',
                },
                {
                    key: 'men_winter_02_4.png',
                    garmentFile: 'garment/men_winter_02_4.png',
                    effectFile: 'effect/men_winter_02_4.png',
                },
                {
                    key: 'men_winter_02_5.png',
                    garmentFile: 'garment/men_winter_02_5.png',
                    effectFile: 'effect/men_winter_02_5.png',
                },
                {
                    key: 'men_winter_02_6.png',
                    garmentFile: 'garment/men_winter_02_6.png',
                    effectFile: 'effect/men_winter_02_6.png',
                },
                {
                    key: 'men_winter_01_1.png',
                    garmentFile: 'garment/men_winter_01_1.png',
                    effectFile: 'effect/men_winter_01_1.png',
                },
                {
                    key: 'men_winter_01_2.png',
                    garmentFile: 'garment/men_winter_01_2.png',
                    effectFile: 'effect/men_winter_01_2.png',
                },
                {
                    key: 'men_winter_01_3.png',
                    garmentFile: 'garment/men_winter_01_3.png',
                    effectFile: 'effect/men_winter_01_3.png',
                },
                {
                    key: 'men_winter_01_4.png',
                    garmentFile: 'garment/men_winter_01_4.png',
                    effectFile: 'effect/men_winter_01_4.png',
                },
            ],
        },
    ],
    female: [
        {
            categoryName: 'business',
            clothes: [
                {
                    key: 'women_business_01_1.png',
                    garmentFile: 'garment/women_business_01_1.png',
                    effectFile: 'effect/women_business_01_1.png',
                },
                {
                    key: 'women_business_01_10.png',
                    garmentFile: 'garment/women_business_01_10.png',
                    effectFile: 'effect/women_business_01_10.png',
                },
                {
                    key: 'women_business_01_11.png',
                    garmentFile: 'garment/women_business_01_11.png',
                    effectFile: 'effect/women_business_01_11.png',
                },
                {
                    key: 'women_business_01_2.png',
                    garmentFile: 'garment/women_business_01_2.png',
                    effectFile: 'effect/women_business_01_2.png',
                },
                {
                    key: 'women_business_01_3.png',
                    garmentFile: 'garment/women_business_01_3.png',
                    effectFile: 'effect/women_business_01_3.png',
                },
                {
                    key: 'women_business_01_4.png',
                    garmentFile: 'garment/women_business_01_4.png',
                    effectFile: 'effect/women_business_01_4.png',
                },
                {
                    key: 'women_business_01_5.png',
                    garmentFile: 'garment/women_business_01_5.png',
                    effectFile: 'effect/women_business_01_5.png',
                },
                {
                    key: 'women_business_01_6.png',
                    garmentFile: 'garment/women_business_01_6.png',
                    effectFile: 'effect/women_business_01_6.png',
                },
                {
                    key: 'women_business_01_7.png',
                    garmentFile: 'garment/women_business_01_7.png',
                    effectFile: 'effect/women_business_01_7.png',
                },
                {
                    key: 'women_business_01_8.png',
                    garmentFile: 'garment/women_business_01_8.png',
                    effectFile: 'effect/women_business_01_8.png',
                },
                {
                    key: 'women_business_01_9.png',
                    garmentFile: 'garment/women_business_01_9.png',
                    effectFile: 'effect/women_business_01_9.png',
                },
                {
                    key: 'women_business_03_1.png',
                    garmentFile: 'garment/women_business_03_1.png',
                    effectFile: 'effect/women_business_03_1.png',
                },
                {
                    key: 'women_business_03_3.png',
                    garmentFile: 'garment/women_business_03_3.png',
                    effectFile: 'effect/women_business_03_3.png',
                },
                {
                    key: 'women_business_03_4.png',
                    garmentFile: 'garment/women_business_03_4.png',
                    effectFile: 'effect/women_business_03_4.png',
                },
                {
                    key: 'women_business_03_5.png',
                    garmentFile: 'garment/women_business_03_5.png',
                    effectFile: 'effect/women_business_03_5.png',
                },
                {
                    key: 'women_business_03_7.png',
                    garmentFile: 'garment/women_business_03_7.png',
                    effectFile: 'effect/women_business_03_7.png',
                },
                {
                    key: 'women_business_03_8.png',
                    garmentFile: 'garment/women_business_03_8.png',
                    effectFile: 'effect/women_business_03_8.png',
                },
                {
                    key: 'women_business_02_1.png',
                    garmentFile: 'garment/women_business_02_1.png',
                    effectFile: 'effect/women_business_02_1.png',
                },
                {
                    key: 'women_business_02_10.png',
                    garmentFile: 'garment/women_business_02_10.png',
                    effectFile: 'effect/women_business_02_10.png',
                },
                {
                    key: 'women_business_02_11.png',
                    garmentFile: 'garment/women_business_02_11.png',
                    effectFile: 'effect/women_business_02_11.png',
                },
                {
                    key: 'women_business_02_2.png',
                    garmentFile: 'garment/women_business_02_2.png',
                    effectFile: 'effect/women_business_02_2.png',
                },
                {
                    key: 'women_business_02_3.png',
                    garmentFile: 'garment/women_business_02_3.png',
                    effectFile: 'effect/women_business_02_3.png',
                },
                {
                    key: 'women_business_02_4.png',
                    garmentFile: 'garment/women_business_02_4.png',
                    effectFile: 'effect/women_business_02_4.png',
                },
                {
                    key: 'women_business_02_5.png',
                    garmentFile: 'garment/women_business_02_5.png',
                    effectFile: 'effect/women_business_02_5.png',
                },
                {
                    key: 'women_business_02_6.png',
                    garmentFile: 'garment/women_business_02_6.png',
                    effectFile: 'effect/women_business_02_6.png',
                },
                {
                    key: 'women_business_02_7.png',
                    garmentFile: 'garment/women_business_02_7.png',
                    effectFile: 'effect/women_business_02_7.png',
                },
                {
                    key: 'women_business_02_8.png',
                    garmentFile: 'garment/women_business_02_8.png',
                    effectFile: 'effect/women_business_02_8.png',
                },
                {
                    key: 'women_business_02_9.png',
                    garmentFile: 'garment/women_business_02_9.png',
                    effectFile: 'effect/women_business_02_9.png',
                },
            ],
        },
        {
            categoryName: 'causal',
            clothes: [
                {
                    key: 'women_causal_01_1.png',
                    garmentFile: 'garment/women_causal_01_1.png',
                    effectFile: 'effect/women_causal_01_1.png',
                },
                {
                    key: 'women_causal_01_10.png',
                    garmentFile: 'garment/women_causal_01_10.png',
                    effectFile: 'effect/women_causal_01_10.png',
                },
                {
                    key: 'women_causal_01_11.png',
                    garmentFile: 'garment/women_causal_01_11.png',
                    effectFile: 'effect/women_causal_01_11.png',
                },
                {
                    key: 'women_causal_01_12.png',
                    garmentFile: 'garment/women_causal_01_12.png',
                    effectFile: 'effect/women_causal_01_12.png',
                },
                {
                    key: 'women_causal_01_13.png',
                    garmentFile: 'garment/women_causal_01_13.png',
                    effectFile: 'effect/women_causal_01_13.png',
                },
                {
                    key: 'women_causal_01_14.png',
                    garmentFile: 'garment/women_causal_01_14.png',
                    effectFile: 'effect/women_causal_01_14.png',
                },
                {
                    key: 'women_causal_01_15.png',
                    garmentFile: 'garment/women_causal_01_15.png',
                    effectFile: 'effect/women_causal_01_15.png',
                },
                {
                    key: 'women_causal_01_16.png',
                    garmentFile: 'garment/women_causal_01_16.png',
                    effectFile: 'effect/women_causal_01_16.png',
                },
                {
                    key: 'women_causal_01_17.png',
                    garmentFile: 'garment/women_causal_01_17.png',
                    effectFile: 'effect/women_causal_01_17.png',
                },
                {
                    key: 'women_causal_01_19.png',
                    garmentFile: 'garment/women_causal_01_19.png',
                    effectFile: 'effect/women_causal_01_19.png',
                },
                {
                    key: 'women_causal_01_2.png',
                    garmentFile: 'garment/women_causal_01_2.png',
                    effectFile: 'effect/women_causal_01_2.png',
                },
                {
                    key: 'women_causal_01_23.png',
                    garmentFile: 'garment/women_causal_01_23.png',
                    effectFile: 'effect/women_causal_01_23.png',
                },
                {
                    key: 'women_causal_01_24.png',
                    garmentFile: 'garment/women_causal_01_24.png',
                    effectFile: 'effect/women_causal_01_24.png',
                },
                {
                    key: 'women_causal_01_25.png',
                    garmentFile: 'garment/women_causal_01_25.png',
                    effectFile: 'effect/women_causal_01_25.png',
                },
                {
                    key: 'women_causal_01_26.png',
                    garmentFile: 'garment/women_causal_01_26.png',
                    effectFile: 'effect/women_causal_01_26.png',
                },
                {
                    key: 'women_causal_01_27.png',
                    garmentFile: 'garment/women_causal_01_27.png',
                    effectFile: 'effect/women_causal_01_27.png',
                },
                {
                    key: 'women_causal_01_28.png',
                    garmentFile: 'garment/women_causal_01_28.png',
                    effectFile: 'effect/women_causal_01_28.png',
                },
                {
                    key: 'women_causal_01_3.png',
                    garmentFile: 'garment/women_causal_01_3.png',
                    effectFile: 'effect/women_causal_01_3.png',
                },
                {
                    key: 'women_causal_01_4.png',
                    garmentFile: 'garment/women_causal_01_4.png',
                    effectFile: 'effect/women_causal_01_4.png',
                },
                {
                    key: 'women_causal_01_6.png',
                    garmentFile: 'garment/women_causal_01_6.png',
                    effectFile: 'effect/women_causal_01_6.png',
                },
                {
                    key: 'women_causal_01_7.png',
                    garmentFile: 'garment/women_causal_01_7.png',
                    effectFile: 'effect/women_causal_01_7.png',
                },
                {
                    key: 'women_causal_01_8.png',
                    garmentFile: 'garment/women_causal_01_8.png',
                    effectFile: 'effect/women_causal_01_8.png',
                },
                {
                    key: 'women_causal_01_9.png',
                    garmentFile: 'garment/women_causal_01_9.png',
                    effectFile: 'effect/women_causal_01_9.png',
                },
                {
                    key: 'women_causal_02_1.png',
                    garmentFile: 'garment/women_causal_02_1.png',
                    effectFile: 'effect/women_causal_02_1.png',
                },
                {
                    key: 'women_causal_02_2.png',
                    garmentFile: 'garment/women_causal_02_2.png',
                    effectFile: 'effect/women_causal_02_2.png',
                },
                {
                    key: 'women_causal_02_3.png',
                    garmentFile: 'garment/women_causal_02_3.png',
                    effectFile: 'effect/women_causal_02_3.png',
                },
                {
                    key: 'women_causal_02_4.png',
                    garmentFile: 'garment/women_causal_02_4.png',
                    effectFile: 'effect/women_causal_02_4.png',
                },
                {
                    key: 'women_causal_02_5.png',
                    garmentFile: 'garment/women_causal_02_5.png',
                    effectFile: 'effect/women_causal_02_5.png',
                },
            ],
        },
        {
            categoryName: 'dress',
            clothes: [
                {
                    key: 'women_dress_01_1.png',
                    garmentFile: 'garment/women_dress_01_1.png',
                    effectFile: 'effect/women_dress_01_1.png',
                },
                {
                    key: 'women_dress_01_10.png',
                    garmentFile: 'garment/women_dress_01_10.png',
                    effectFile: 'effect/women_dress_01_10.png',
                },
                {
                    key: 'women_dress_01_11.png',
                    garmentFile: 'garment/women_dress_01_11.png',
                    effectFile: 'effect/women_dress_01_11.png',
                },
                {
                    key: 'women_dress_01_12.png',
                    garmentFile: 'garment/women_dress_01_12.png',
                    effectFile: 'effect/women_dress_01_12.png',
                },
                {
                    key: 'women_dress_01_13.png',
                    garmentFile: 'garment/women_dress_01_13.png',
                    effectFile: 'effect/women_dress_01_13.png',
                },
                {
                    key: 'women_dress_01_14.png',
                    garmentFile: 'garment/women_dress_01_14.png',
                    effectFile: 'effect/women_dress_01_14.png',
                },
                {
                    key: 'women_dress_01_15.png',
                    garmentFile: 'garment/women_dress_01_15.png',
                    effectFile: 'effect/women_dress_01_15.png',
                },
                {
                    key: 'women_dress_01_16.png',
                    garmentFile: 'garment/women_dress_01_16.png',
                    effectFile: 'effect/women_dress_01_16.png',
                },
                {
                    key: 'women_dress_01_17.png',
                    garmentFile: 'garment/women_dress_01_17.png',
                    effectFile: 'effect/women_dress_01_17.png',
                },
                {
                    key: 'women_dress_01_18.png',
                    garmentFile: 'garment/women_dress_01_18.png',
                    effectFile: 'effect/women_dress_01_18.png',
                },
                {
                    key: 'women_dress_01_2.png',
                    garmentFile: 'garment/women_dress_01_2.png',
                    effectFile: 'effect/women_dress_01_2.png',
                },
                {
                    key: 'women_dress_01_20.png',
                    garmentFile: 'garment/women_dress_01_20.png',
                    effectFile: 'effect/women_dress_01_20.png',
                },
                {
                    key: 'women_dress_01_21.png',
                    garmentFile: 'garment/women_dress_01_21.png',
                    effectFile: 'effect/women_dress_01_21.png',
                },
                {
                    key: 'women_dress_01_22.png',
                    garmentFile: 'garment/women_dress_01_22.png',
                    effectFile: 'effect/women_dress_01_22.png',
                },
                {
                    key: 'women_dress_01_23.png',
                    garmentFile: 'garment/women_dress_01_23.png',
                    effectFile: 'effect/women_dress_01_23.png',
                },
                {
                    key: 'women_dress_01_24.png',
                    garmentFile: 'garment/women_dress_01_24.png',
                    effectFile: 'effect/women_dress_01_24.png',
                },
                {
                    key: 'women_dress_01_25.png',
                    garmentFile: 'garment/women_dress_01_25.png',
                    effectFile: 'effect/women_dress_01_25.png',
                },
                {
                    key: 'women_dress_01_26.png',
                    garmentFile: 'garment/women_dress_01_26.png',
                    effectFile: 'effect/women_dress_01_26.png',
                },
                {
                    key: 'women_dress_01_27.png',
                    garmentFile: 'garment/women_dress_01_27.png',
                    effectFile: 'effect/women_dress_01_27.png',
                },
                {
                    key: 'women_dress_01_28.png',
                    garmentFile: 'garment/women_dress_01_28.png',
                    effectFile: 'effect/women_dress_01_28.png',
                },
                {
                    key: 'women_dress_01_3.png',
                    garmentFile: 'garment/women_dress_01_3.png',
                    effectFile: 'effect/women_dress_01_3.png',
                },
                {
                    key: 'women_dress_01_4.png',
                    garmentFile: 'garment/women_dress_01_4.png',
                    effectFile: 'effect/women_dress_01_4.png',
                },
                {
                    key: 'women_dress_01_5.png',
                    garmentFile: 'garment/women_dress_01_5.png',
                    effectFile: 'effect/women_dress_01_5.png',
                },
                {
                    key: 'women_dress_01_7.png',
                    garmentFile: 'garment/women_dress_01_7.png',
                    effectFile: 'effect/women_dress_01_7.png',
                },
                {
                    key: 'women_dress_01_8.png',
                    garmentFile: 'garment/women_dress_01_8.png',
                    effectFile: 'effect/women_dress_01_8.png',
                },
                {
                    key: 'women_dress_01_9.png',
                    garmentFile: 'garment/women_dress_01_9.png',
                    effectFile: 'effect/women_dress_01_9.png',
                },
                {
                    key: 'women_dress_02_1.png',
                    garmentFile: 'garment/women_dress_02_1.png',
                    effectFile: 'effect/women_dress_02_1.png',
                },
                {
                    key: 'women_dress_02_11.png',
                    garmentFile: 'garment/women_dress_02_11.png',
                    effectFile: 'effect/women_dress_02_11.png',
                },
                {
                    key: 'women_dress_02_12.png',
                    garmentFile: 'garment/women_dress_02_12.png',
                    effectFile: 'effect/women_dress_02_12.png',
                },
                {
                    key: 'women_dress_02_13.png',
                    garmentFile: 'garment/women_dress_02_13.png',
                    effectFile: 'effect/women_dress_02_13.png',
                },
                {
                    key: 'women_dress_02_14.png',
                    garmentFile: 'garment/women_dress_02_14.png',
                    effectFile: 'effect/women_dress_02_14.png',
                },
                {
                    key: 'women_dress_02_2.png',
                    garmentFile: 'garment/women_dress_02_2.png',
                    effectFile: 'effect/women_dress_02_2.png',
                },
                {
                    key: 'women_dress_02_3.png',
                    garmentFile: 'garment/women_dress_02_3.png',
                    effectFile: 'effect/women_dress_02_3.png',
                },
                {
                    key: 'women_dress_02_4.png',
                    garmentFile: 'garment/women_dress_02_4.png',
                    effectFile: 'effect/women_dress_02_4.png',
                },
                {
                    key: 'women_dress_02_5.png',
                    garmentFile: 'garment/women_dress_02_5.png',
                    effectFile: 'effect/women_dress_02_5.png',
                },
                {
                    key: 'women_dress_02_6.png',
                    garmentFile: 'garment/women_dress_02_6.png',
                    effectFile: 'effect/women_dress_02_6.png',
                },
                {
                    key: 'women_dress_02_7.png',
                    garmentFile: 'garment/women_dress_02_7.png',
                    effectFile: 'effect/women_dress_02_7.png',
                },
                {
                    key: 'women_dress_02_8.png',
                    garmentFile: 'garment/women_dress_02_8.png',
                    effectFile: 'effect/women_dress_02_8.png',
                },
                {
                    key: 'women_dress_02_9.png',
                    garmentFile: 'garment/women_dress_02_9.png',
                    effectFile: 'effect/women_dress_02_9.png',
                },
            ],
        },
        {
            categoryName: 'party',
            clothes: [
                {
                    key: 'women_party_01_1.png',
                    garmentFile: 'garment/women_party_01_1.png',
                    effectFile: 'effect/women_party_01_1.png',
                },
                {
                    key: 'women_party_01_10.png',
                    garmentFile: 'garment/women_party_01_10.png',
                    effectFile: 'effect/women_party_01_10.png',
                },
                {
                    key: 'women_party_01_11.png',
                    garmentFile: 'garment/women_party_01_11.png',
                    effectFile: 'effect/women_party_01_11.png',
                },
                {
                    key: 'women_party_01_12.png',
                    garmentFile: 'garment/women_party_01_12.png',
                    effectFile: 'effect/women_party_01_12.png',
                },
                {
                    key: 'women_party_01_13.png',
                    garmentFile: 'garment/women_party_01_13.png',
                    effectFile: 'effect/women_party_01_13.png',
                },
                {
                    key: 'women_party_01_15.png',
                    garmentFile: 'garment/women_party_01_15.png',
                    effectFile: 'effect/women_party_01_15.png',
                },
                {
                    key: 'women_party_01_16.png',
                    garmentFile: 'garment/women_party_01_16.png',
                    effectFile: 'effect/women_party_01_16.png',
                },
                {
                    key: 'women_party_01_17.png',
                    garmentFile: 'garment/women_party_01_17.png',
                    effectFile: 'effect/women_party_01_17.png',
                },
                {
                    key: 'women_party_01_18.png',
                    garmentFile: 'garment/women_party_01_18.png',
                    effectFile: 'effect/women_party_01_18.png',
                },
                {
                    key: 'women_party_01_2.png',
                    garmentFile: 'garment/women_party_01_2.png',
                    effectFile: 'effect/women_party_01_2.png',
                },
                {
                    key: 'women_party_01_20.png',
                    garmentFile: 'garment/women_party_01_20.png',
                    effectFile: 'effect/women_party_01_20.png',
                },
                {
                    key: 'women_party_01_21.png',
                    garmentFile: 'garment/women_party_01_21.png',
                    effectFile: 'effect/women_party_01_21.png',
                },
                {
                    key: 'women_party_01_22.png',
                    garmentFile: 'garment/women_party_01_22.png',
                    effectFile: 'effect/women_party_01_22.png',
                },
                {
                    key: 'women_party_01_24.png',
                    garmentFile: 'garment/women_party_01_24.png',
                    effectFile: 'effect/women_party_01_24.png',
                },
                {
                    key: 'women_party_01_25.png',
                    garmentFile: 'garment/women_party_01_25.png',
                    effectFile: 'effect/women_party_01_25.png',
                },
                {
                    key: 'women_party_01_3.png',
                    garmentFile: 'garment/women_party_01_3.png',
                    effectFile: 'effect/women_party_01_3.png',
                },
                {
                    key: 'women_party_01_4.png',
                    garmentFile: 'garment/women_party_01_4.png',
                    effectFile: 'effect/women_party_01_4.png',
                },
                {
                    key: 'women_party_01_5.png',
                    garmentFile: 'garment/women_party_01_5.png',
                    effectFile: 'effect/women_party_01_5.png',
                },
                {
                    key: 'women_party_01_6.png',
                    garmentFile: 'garment/women_party_01_6.png',
                    effectFile: 'effect/women_party_01_6.png',
                },
                {
                    key: 'women_party_01_7.png',
                    garmentFile: 'garment/women_party_01_7.png',
                    effectFile: 'effect/women_party_01_7.png',
                },
                {
                    key: 'women_party_01_8.png',
                    garmentFile: 'garment/women_party_01_8.png',
                    effectFile: 'effect/women_party_01_8.png',
                },
                {
                    key: 'women_party_01_9.png',
                    garmentFile: 'garment/women_party_01_9.png',
                    effectFile: 'effect/women_party_01_9.png',
                },
            ],
        },
        {
            categoryName: 'sport',
            clothes: [
                {
                    key: 'women_sport_02_10.png',
                    garmentFile: 'garment/women_sport_02_10.png',
                    effectFile: 'effect/women_sport_02_10.png',
                },
                {
                    key: 'women_sport_02_11.png',
                    garmentFile: 'garment/women_sport_02_11.png',
                    effectFile: 'effect/women_sport_02_11.png',
                },
                {
                    key: 'women_sport_02_13.png',
                    garmentFile: 'garment/women_sport_02_13.png',
                    effectFile: 'effect/women_sport_02_13.png',
                },
                {
                    key: 'women_sport_02_14.png',
                    garmentFile: 'garment/women_sport_02_14.png',
                    effectFile: 'effect/women_sport_02_14.png',
                },
                {
                    key: 'women_sport_02_15.png',
                    garmentFile: 'garment/women_sport_02_15.png',
                    effectFile: 'effect/women_sport_02_15.png',
                },
                {
                    key: 'women_sport_02_16.png',
                    garmentFile: 'garment/women_sport_02_16.png',
                    effectFile: 'effect/women_sport_02_16.png',
                },
                {
                    key: 'women_sport_02_2.png',
                    garmentFile: 'garment/women_sport_02_2.png',
                    effectFile: 'effect/women_sport_02_2.png',
                },
                {
                    key: 'women_sport_02_3.png',
                    garmentFile: 'garment/women_sport_02_3.png',
                    effectFile: 'effect/women_sport_02_3.png',
                },
                {
                    key: 'women_sport_02_4.png',
                    garmentFile: 'garment/women_sport_02_4.png',
                    effectFile: 'effect/women_sport_02_4.png',
                },
                {
                    key: 'women_sport_02_5.png',
                    garmentFile: 'garment/women_sport_02_5.png',
                    effectFile: 'effect/women_sport_02_5.png',
                },
                {
                    key: 'women_sport_02_6.png',
                    garmentFile: 'garment/women_sport_02_6.png',
                    effectFile: 'effect/women_sport_02_6.png',
                },
                {
                    key: 'women_sport_02_7.png',
                    garmentFile: 'garment/women_sport_02_7.png',
                    effectFile: 'effect/women_sport_02_7.png',
                },
                {
                    key: 'women_sport_02_8.png',
                    garmentFile: 'garment/women_sport_02_8.png',
                    effectFile: 'effect/women_sport_02_8.png',
                },
                {
                    key: 'women_sport_01_1.png',
                    garmentFile: 'garment/women_sport_01_1.png',
                    effectFile: 'effect/women_sport_01_1.png',
                },
                {
                    key: 'women_sport_01_2.png',
                    garmentFile: 'garment/women_sport_01_2.png',
                    effectFile: 'effect/women_sport_01_2.png',
                },
                {
                    key: 'women_sport_01_4.png',
                    garmentFile: 'garment/women_sport_01_4.png',
                    effectFile: 'effect/women_sport_01_4.png',
                },
                {
                    key: 'women_sport_01_5.png',
                    garmentFile: 'garment/women_sport_01_5.png',
                    effectFile: 'effect/women_sport_01_5.png',
                },
                {
                    key: 'women_sport_01_6.png',
                    garmentFile: 'garment/women_sport_01_6.png',
                    effectFile: 'effect/women_sport_01_6.png',
                },
                {
                    key: 'women_sport_01_7.png',
                    garmentFile: 'garment/women_sport_01_7.png',
                    effectFile: 'effect/women_sport_01_7.png',
                },
                {
                    key: 'women_sport_01_8.png',
                    garmentFile: 'garment/women_sport_01_8.png',
                    effectFile: 'effect/women_sport_01_8.png',
                },
                {
                    key: 'women_sport_01_9.png',
                    garmentFile: 'garment/women_sport_01_9.png',
                    effectFile: 'effect/women_sport_01_9.png',
                },
            ],
        },
        {
            categoryName: 'summer',
            clothes: [
                {
                    key: 'women_summer_01_1.png',
                    garmentFile: 'garment/women_summer_01_1.png',
                    effectFile: 'effect/women_summer_01_1.png',
                },
                {
                    key: 'women_summer_01_10.png',
                    garmentFile: 'garment/women_summer_01_10.png',
                    effectFile: 'effect/women_summer_01_10.png',
                },
                {
                    key: 'women_summer_01_11.png',
                    garmentFile: 'garment/women_summer_01_11.png',
                    effectFile: 'effect/women_summer_01_11.png',
                },
                {
                    key: 'women_summer_01_2.png',
                    garmentFile: 'garment/women_summer_01_2.png',
                    effectFile: 'effect/women_summer_01_2.png',
                },
                {
                    key: 'women_summer_01_3.png',
                    garmentFile: 'garment/women_summer_01_3.png',
                    effectFile: 'effect/women_summer_01_3.png',
                },
                {
                    key: 'women_summer_01_4.png',
                    garmentFile: 'garment/women_summer_01_4.png',
                    effectFile: 'effect/women_summer_01_4.png',
                },
                {
                    key: 'women_summer_01_5.png',
                    garmentFile: 'garment/women_summer_01_5.png',
                    effectFile: 'effect/women_summer_01_5.png',
                },
                {
                    key: 'women_summer_01_6.png',
                    garmentFile: 'garment/women_summer_01_6.png',
                    effectFile: 'effect/women_summer_01_6.png',
                },
                {
                    key: 'women_summer_01_7.png',
                    garmentFile: 'garment/women_summer_01_7.png',
                    effectFile: 'effect/women_summer_01_7.png',
                },
                {
                    key: 'women_summer_01_8.png',
                    garmentFile: 'garment/women_summer_01_8.png',
                    effectFile: 'effect/women_summer_01_8.png',
                },
                {
                    key: 'women_summer_01_9.png',
                    garmentFile: 'garment/women_summer_01_9.png',
                    effectFile: 'effect/women_summer_01_9.png',
                },
            ],
        },
        {
            categoryName: 'wedding',
            clothes: [
                {
                    key: 'women_wedding_02_1.png',
                    garmentFile: 'garment/women_wedding_02_1.png',
                    effectFile: 'effect/women_wedding_02_1.png',
                },
                {
                    key: 'women_wedding_02_2.png',
                    garmentFile: 'garment/women_wedding_02_2.png',
                    effectFile: 'effect/women_wedding_02_2.png',
                },
                {
                    key: 'women_wedding_02_3.png',
                    garmentFile: 'garment/women_wedding_02_3.png',
                    effectFile: 'effect/women_wedding_02_3.png',
                },
                {
                    key: 'women_wedding_02_4.png',
                    garmentFile: 'garment/women_wedding_02_4.png',
                    effectFile: 'effect/women_wedding_02_4.png',
                },
                {
                    key: 'women_wedding_02_5.png',
                    garmentFile: 'garment/women_wedding_02_5.png',
                    effectFile: 'effect/women_wedding_02_5.png',
                },
                {
                    key: 'women_wedding_02_6.png',
                    garmentFile: 'garment/women_wedding_02_6.png',
                    effectFile: 'effect/women_wedding_02_6.png',
                },
                {
                    key: 'women_wedding_02_7.png',
                    garmentFile: 'garment/women_wedding_02_7.png',
                    effectFile: 'effect/women_wedding_02_7.png',
                },
                {
                    key: 'women_wedding_02_8.png',
                    garmentFile: 'garment/women_wedding_02_8.png',
                    effectFile: 'effect/women_wedding_02_8.png',
                },
                {
                    key: 'women_wedding_01_1.png',
                    garmentFile: 'garment/women_wedding_01_1.png',
                    effectFile: 'effect/women_wedding_01_1.png',
                },
                {
                    key: 'women_wedding_01_2.png',
                    garmentFile: 'garment/women_wedding_01_2.png',
                    effectFile: 'effect/women_wedding_01_2.png',
                },
                {
                    key: 'women_wedding_01_3.png',
                    garmentFile: 'garment/women_wedding_01_3.png',
                    effectFile: 'effect/women_wedding_01_3.png',
                },
                {
                    key: 'women_wedding_01_4.png',
                    garmentFile: 'garment/women_wedding_01_4.png',
                    effectFile: 'effect/women_wedding_01_4.png',
                },
                {
                    key: 'women_wedding_03_1.png',
                    garmentFile: 'garment/women_wedding_03_1.png',
                    effectFile: 'effect/women_wedding_03_1.png',
                },
                {
                    key: 'women_wedding_03_3.png',
                    garmentFile: 'garment/women_wedding_03_3.png',
                    effectFile: 'effect/women_wedding_03_3.png',
                },
            ],
        },
        {
            categoryName: 'winter',
            clothes: [
                {
                    key: 'women_winter_01_1.png',
                    garmentFile: 'garment/women_winter_01_1.png',
                    effectFile: 'effect/women_winter_01_1.png',
                },
                {
                    key: 'women_winter_01_2.png',
                    garmentFile: 'garment/women_winter_01_2.png',
                    effectFile: 'effect/women_winter_01_2.png',
                },
                {
                    key: 'women_winter_01_3.png',
                    garmentFile: 'garment/women_winter_01_3.png',
                    effectFile: 'effect/women_winter_01_3.png',
                },
                {
                    key: 'women_winter_01_4.png',
                    garmentFile: 'garment/women_winter_01_4.png',
                    effectFile: 'effect/women_winter_01_4.png',
                },
                {
                    key: 'women_winter_01_5.png',
                    garmentFile: 'garment/women_winter_01_5.png',
                    effectFile: 'effect/women_winter_01_5.png',
                },
                {
                    key: 'women_winter_02_2.png',
                    garmentFile: 'garment/women_winter_02_2.png',
                    effectFile: 'effect/women_winter_02_2.png',
                },
                {
                    key: 'women_winter_02_3.png',
                    garmentFile: 'garment/women_winter_02_3.png',
                    effectFile: 'effect/women_winter_02_3.png',
                },
                {
                    key: 'women_winter_02_4.png',
                    garmentFile: 'garment/women_winter_02_4.png',
                    effectFile: 'effect/women_winter_02_4.png',
                },
            ],
        },
    ],
};
